/* eslint-disable no-undef */
import produce from '../utils/produce'

export const initialState = {
    domain: null, // pc, shopping, minishop
    minishopInfo: null,
    selectCategory: null,
    layerPopup: null,
    orangeLayerPopup : {
        title : '',
        notice : '',
    },
    selectedFilters: {
        spec: {},
        maker: [],
        kwd: '',
        min: 0,
        max: 0,
    },
    selectedFilterNum: 0,
    setSearchDataOption: {},
    setSearchPriceOption: {
        list : []
    },
    lists: {
        itemList: [],
        advList: null,
        curation: null,
        event: [],
    },
    initRoute: false, // 주소창에서 라우트값 받아왔는지
    route: {
        pageType: 'srch', // 검색페이지
        tab: 'total', // 탭 total, compare, mguide, mreview, curation
        types: 'list', // 리스트형태 list, thumb
        page: '1', // 페이지
        sort: 'rank', // 정렬 - 1:인기(rank) 2: 신상(date) 3: 높은가격(price_desc) 4: 낮은가격(price_asc) 5:가나다(abc) 6: 판매점(mall) 7: 상품평(review)
        size: '30', // 노출개수
        srch_cond: null, // 검색조건 (selectedFilters)
        type: 'cash', // 2022-08-02 현금가(cash) : 전체 최저가, 카드가(card) :카드 최저가 노출되게 수정
    },
    filterOptionAll: false,
    loading: {
        setSearchDataOption: false,
        setItemList: false,
        setCuration: false
    },
    serviceOsList  : [],
}

export const SET_DOMAIN = 'SET_DOMAIN'
export const MINISHOP_INFO_REQUEST = 'MINISHOP_INFO_REQUEST'
export const MINISHOP_INFO_SUCCESS = 'MINISHOP_INFO_SUCCESS'
export const MINISHOP_INFO_FAILURE = 'MINISHOP_INFO_FAILURE'
export const SELECT_CATEGOTY = 'SELECT_CATEGOTY'
export const LAYER_POPUP = 'LAYER_POPUP'
export const LAYER_ORANGE_POPUP = 'LAYER_ORANGE_POPUP'
export const SEARCH_DATA_REQUEST = 'SEARCH_DATA_REQUEST'
export const SEARCH_DATA_SUCCESS = 'SEARCH_DATA_SUCCESS'
export const SEARCH_DATA_FAILURE = 'SEARCH_DATA_FAILURE'
export const SEARCH_PRICE_REQUEST = 'SEARCH_PRICE_REQUEST'
export const SEARCH_PRICE_SUCCESS = 'SEARCH_PRICE_SUCCESS'
export const SEARCH_PRICE_FAILURE = 'SEARCH_PRICE_FAILURE'
export const ADV_LIST_REQUEST = 'ADV_LIST_REQUEST'
export const ADV_LIST_SUCCESS = 'ADV_LIST_SUCCESS'
export const ADV_LIST_FAILURE = 'ADV_LIST_FAILURE'
export const CURATION_REQUEST = 'CURATION_REQUEST'
export const CURATION_SUCCESS = 'CURATION_SUCCESS'
export const CURATION_FAILURE = 'CURATION_FAILURE'
export const HOT_EVENT_REQUEST = 'HOT_EVENT_REQUEST'
export const HOT_EVENT_SUCCESS = 'HOT_EVENT_SUCCESS'
export const HOT_EVENT_FAILURE = 'HOT_EVENT_FAILURE'
export const ITEM_LIST_REQUEST = 'ITEM_LIST_REQUEST'
export const ITEM_LIST_SUCCESS = 'ITEM_LIST_SUCCESS'
export const ITEM_LIST_FAILURE = 'ITEM_LIST_FAILURE'
export const SET_INIT_ROUTE = 'SET_INIT_ROUTE'
export const SET_ROUTE = 'SET_ROUTE'
export const SET_SELECTED_FILTER = 'SET_SELECTED_FILTER'
export const SET_SELECTED_FILTER_NUM = 'SET_SELECTED_FILTER_NUM'
export const SET_FILTER_OPTION_ALL = 'SET_FILTER_OPTION_ALL'
export const SET_ITEM_MORE_VIEW = 'SET_ITEM_MORE_VIEW'

export const SET_SERVICE_OS_LIST = 'SET_SERVICE_OS_LIST'

export default (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case SET_DOMAIN: {
                draft.domain = action.data
                break
            }
            case SELECT_CATEGOTY: {
                draft.selectCategory = action.data
                break
            }
            case LAYER_POPUP: {
                draft.layerPopup = action.data
                break
            }
            case LAYER_ORANGE_POPUP: {
                draft.orangeLayerPopup = action.data
                break
            }
            case SEARCH_DATA_REQUEST: {
                draft.loading.setSearchDataOption = true
                break
            }
            case SEARCH_DATA_SUCCESS: {
                draft.setSearchDataOption = action.data
                draft.loading.setSearchDataOption = false
                break
            }
            case SEARCH_DATA_FAILURE: {
                break
            }
            case SEARCH_PRICE_REQUEST: {
                break
            }
            case SEARCH_PRICE_SUCCESS: {
                draft.setSearchPriceOption = action.data
                break
            }
            case SEARCH_PRICE_FAILURE: {
                break
            }
            case MINISHOP_INFO_REQUEST: {
                break
            }
            case MINISHOP_INFO_SUCCESS: {
                draft.minishopInfo = action.data
                break
            }
            case MINISHOP_INFO_FAILURE: {
                break
            }
            case ADV_LIST_REQUEST: {
                break
            }
            case ADV_LIST_SUCCESS: {
                draft.lists.advList = action.data
                break
            }
            case ADV_LIST_FAILURE: {
                break
            }
            case CURATION_REQUEST: {
                draft.loading.setCuration = true
                break
            }
            case CURATION_SUCCESS: {
                draft.lists.curation = action.data
                draft.loading.setCuration = false
                break
            }
            case CURATION_FAILURE: {
                draft.loading.setCuration = false
                break
            }
            case HOT_EVENT_REQUEST: {
                break
            }
            case HOT_EVENT_SUCCESS: {
                draft.lists.event = action.data
                break
            }
            case HOT_EVENT_FAILURE: {
                break
            }
            case ITEM_LIST_REQUEST: {
                draft.loading.setItemList = true
                break
            }
            case ITEM_LIST_SUCCESS: {
                draft.lists.itemList = action.data
                draft.loading.setItemList = false
                break
            }
            case ITEM_LIST_FAILURE: {
                break
            }
            case SET_ROUTE: {
                const data = { ...state.route, ...action.data }

                // 2022-08-02 상품분류 이동시 '일반 전문몰', '카드 전문몰' 에 따라 초기값 변경
                let btn_type = document.getElementById('id-m2')
                if (btn_type !== undefined && btn_type !== null) {
                    if (data.type === 'cash' && btn_type.checked) {
                        data.type = 'card'
                    }
                }

                draft.route = data
                break
            }
            case SET_INIT_ROUTE: {
                draft.initRoute = true
                break
            }
            case SET_SELECTED_FILTER: {
                const data = { ...state.selectedFilters, ...action.data }
                draft.selectedFilters = data
                break
            }
            case SET_SELECTED_FILTER_NUM: {
                draft.selectedFilterNum = action.data
                break
            }
            case SET_FILTER_OPTION_ALL: {
                draft.filterOptionAll = action.data
                break
            }
            case SET_ITEM_MORE_VIEW: {
                const items =
                    action.data.like === 'curation'
                        ? draft.lists.curation.curation[action.data.curationIndex].items
                        : draft.lists.itemList.items
                const findIndex = items.findIndex((v) => v.item_id === action.data.id)
                const findGroup = Math.floor(findIndex / 3)
                const groupindexArr = [findGroup * 3, findGroup * 3 + 1, findGroup * 3 + 2].filter(
                    (v) => v !== findIndex,
                )
                groupindexArr.forEach((v, i) => {
                    if (items[groupindexArr[i]]) {
                        items[groupindexArr[i]].moreView = false
                    }
                })

                const found = items.find((v) => v.item_id === action.data.id)
                found.moreView = !found.moreView
                break
            }
            case SET_SERVICE_OS_LIST: {
                draft.serviceOsList = action.data
            }
            default: {
                break
            }
        }
    })
}



// WEBPACK FOOTER //
// ./src/estimate_list/reducers/initial.js